import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexibleCameraType, ViewSettings } from '../../../../../../viewer/view-settings';
import { ToolIcon } from '../../tool-icon';
import { useViewSettings } from './use-view-settings';

type Props = {
  camera: FlexibleCameraType;
};

/**
 * Switches the flexible viewing mode's camera, keeping the shown layers.
 */
const FlexibleCameraTool = (props: Props) => {
  const { t } = useTranslation();
  const { camera } = useViewSettings();

  const tooltip =
    props.camera === 'perspective'
      ? {
          title: t('viewSettings.camera.perspective.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('viewSettings.camera.perspective.tooltip.text', { ns: 'skyviewToolbar' }),
        }
      : {
          title: t('viewSettings.camera.orthographic.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('viewSettings.camera.orthographic.tooltip.text', { ns: 'skyviewToolbar' }),
        };

  return (
    <ToolIcon
      active={camera === props.camera}
      callback={() => ViewSettings.instance.setCamera(props.camera)}
      icon={props.camera === 'perspective' ? ['fal', 'cube'] : ['fal', 'map']}
      tooltip={tooltip}
    />
  );
};

export { FlexibleCameraTool };
